import { Component } from '@angular/core';

@Component({
  selector: 'shared-contact-loader',
  templateUrl: './contact-loader.component.html',
  styleUrls: ['./contact-loader.component.scss'],
})
export class ContactLoaderComponent {
}
